import { canAgencyCharge, ProductTypes, type ProductType } from '../../types';
import {
  ACTIVE_STATUS,
  BOUND_STATUS,
  IN_FORCE_STATUS,
  ISSUED_STATUS,
} from '../_statics/quote.statics';

export interface ChargeFacts {
  /** An agency admin: the charge is an agency admin's step. */
  readonly isAgencyAdmin: boolean;
  /** PortalOne is a jQuery plugin, so nothing can open it before jQuery has loaded. */
  readonly isJQueryLoaded: boolean;
  readonly totalPremium: number | null | undefined;
  readonly isPaid: boolean;
  readonly product: string;
}

/** Whether an agency may charge a policy's or binder's premium through OneInc: an unpaid premium on a product it charges for. */
export const canChargePolicy = (facts: ChargeFacts): boolean =>
  facts.isJQueryLoaded &&
  facts.isAgencyAdmin &&
  facts.totalPremium != null &&
  facts.totalPremium > 0 &&
  !facts.isPaid &&
  canAgencyCharge(facts.product as ProductType);

/** The policy statuses the agency Policies listing reads as active, which are the ones it offers a charge on. */
export const LEGACY_CHARGEABLE_POLICY_STATUSES: readonly string[] = [
  ACTIVE_STATUS,
  IN_FORCE_STATUS,
  ISSUED_STATUS,
  BOUND_STATUS,
];

export interface LegacyPolicyChargeFacts {
  readonly status: string;
  readonly isPaid?: boolean;
}

/**
 * Whether the agency Policies listing offers to charge a P100 or P250 policy: an active policy whose premium is unpaid.
 * Its items stay disabled until jQuery has loaded, which the caller decides.
 */
export const canChargeLegacyPolicy = (
  facts: LegacyPolicyChargeFacts
): boolean =>
  LEGACY_CHARGEABLE_POLICY_STATUSES.includes(facts.status) && !facts.isPaid;

export interface LegacyBinderChargeFacts {
  readonly status: string;
  readonly isPaid?: boolean;
  readonly totalPremium?: number | null;
  readonly product: string;
}

/**
 * Whether the agency Binders listing offers to charge a legacy binder: a bound P250 binder with an unpaid premium. Its
 * items stay disabled until jQuery has loaded, which the caller decides.
 */
export const canChargeLegacyBinder = (
  facts: LegacyBinderChargeFacts
): boolean =>
  !facts.isPaid &&
  facts.totalPremium != null &&
  facts.totalPremium > 0 &&
  facts.status === BOUND_STATUS &&
  facts.product === ProductTypes.p250;
